import React from 'react';
import { Info } from 'lucide-react';
import { GLYCEMIC_LOAD_CATEGORIES } from '../../utils/constants';

/**
 * Legend Component - Shows glycemic load categories
 */
const Legend = () => {
  const categories = [
    {
      ...GLYCEMIC_LOAD_CATEGORIES.VERY_LOW,
      label: 'Très faible',
      description: 'CG ≤ 5',
      colorClass: 'bg-green-50 border-green-200',
      textClass: 'text-green-800'
    },
    {
      ...GLYCEMIC_LOAD_CATEGORIES.LOW,
      label: 'Faible',
      description: 'CG 6-10',
      colorClass: 'bg-yellow-50 border-yellow-200',
      textClass: 'text-yellow-800'
    },
    {
      ...GLYCEMIC_LOAD_CATEGORIES.MODERATE,
      label: 'Modérée',
      description: 'CG 11-20',
      colorClass: 'bg-orange-50 border-orange-200',
      textClass: 'text-orange-800'
    },
    {
      name: GLYCEMIC_LOAD_CATEGORIES.HIGH.name,
      emoji: GLYCEMIC_LOAD_CATEGORIES.HIGH.emoji,
      label: 'Élevée',
      description: 'CG > 20',
      colorClass: 'bg-red-50 border-red-200',
      textClass: 'text-red-800'
    }
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <Info className="w-5 h-5 text-blue-600" />
        Légende des charges glycémiques
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {categories.map((category) => (
          <div 
            key={category.name}
            className={`flex items-center gap-3 p-3 rounded-lg border ${category.colorClass}`}
          >
            <span className="text-2xl">{category.emoji}</span>
            <div>
              <div className={`font-medium ${category.textClass}`}>
                {category.label}
              </div>
              <div className={`text-sm ${category.textClass.replace('800', '600')}`}>
                {category.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend;